import constants from '@/Constants';
import { getSubdomain } from '@/utils/getSubdomain';
import { createContext } from '@/utils/react-utils';
import snakeToCamel from '@/utils/snakeToCamel';
import axios from 'axios';
import React from 'react';
import { useQuery } from 'react-query';

import { ItemWithSections } from '../interfaces';
import { useInteractions } from './useInteractions';

export type EventItemShowContext = {
  item: ItemWithSections | undefined;
  refetch: () => void;
  isLoading?: boolean;
};

const [Context, useEventItemShow] = createContext<EventItemShowContext>({
  name: 'EventItemShowContext',
});

const EventItemShowProvider: React.FC = ({ children }) => {
  const { selectedItemId } = useInteractions();
  const subdomainFromHost = getSubdomain();

  const url = constants.REPORTS_API_URL || '';
  const parsedUrl = url
    .toLowerCase()
    .replace('{{workspace}}', subdomainFromHost);

  const fetchEventItemShow = async () => {
    const { data } = await axios.get<ItemWithSections>(
      `${parsedUrl}external_answer_pictures?item_id=${selectedItemId}`,
      {
        headers: {
          Authorization: constants.REPORTS_API_AUTHORIZATION_TOKEN,
        },
      },
    );
    return snakeToCamel(data);
  };

  const { data, isLoading, refetch } = useQuery<ItemWithSections | undefined>(
    ['eventItemShow', selectedItemId],
    fetchEventItemShow,
    {
      enabled: !!selectedItemId,
      refetchOnWindowFocus: false,
    },
  );

  return (
    <Context
      value={{
        refetch,
        item: data,
        isLoading,
      }}
    >
      {children}
    </Context>
  );
};

export { useEventItemShow, EventItemShowProvider };
